import { FC, useMemo } from 'react';
import ArrowIcon from 'components/UI/Icon/ArrowIcon';
import { ActiveTitle, InactiveTitle, Root } from './styled';
import { FormattedMessage } from 'react-intl';
import { Upper } from 'components/UI/Heading/styled';

type Props = {
  titleId?: string;
  title?: string;
  active: boolean;
  setActive: (value: boolean) => void;
};

const header = (titleId: string | undefined, title: string | undefined) => {
  if (title) {
    return title;
  }
  return <FormattedMessage id={titleId} />;
};

const AccordionHeaderTitle: FC<Props> = ({
  titleId,
  title,
  active,
  setActive,
}) => {
  const formatedTitle = useMemo(() => {
    if (active) {
      return (
        <ActiveTitle>
          <Upper>{header(titleId, title)}</Upper>
        </ActiveTitle>
      );
    }
    return (
      <InactiveTitle>
        <Upper>{header(titleId, title)}</Upper>
      </InactiveTitle>
    );
  }, [active, titleId, title]);

  return (
    <Root onClick={() => setActive(!active)}>
      {formatedTitle}
      <ArrowIcon
        size="small"
        direction={active ? 'up' : 'down'}
        color={active ? '#F35321' : '#686867'}
        transition={false}
      />
    </Root>
  );
};

export default AccordionHeaderTitle;
